module.exports = __webpack_public_path__ + "static/media/ribbon.551f6b7b.svg";